exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-wrapper[data-v-8ea2a440]{margin-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-8ea2a440&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/SchoolOpenGiftPack.vue
// module id = 604
// module chunks = 0